var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery, useMutation, useQuery, useReactiveVar } from '@apollo/client';
import { Button, TextField } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { FeedbackTargetTypes } from 'common/enums/feedback/feedback-target-types.enum';
import { CREATE_FEEDBACK } from 'common/graphql/mutations/feedback/create-feedback';
import { USER_FEEDBACKS } from 'common/graphql/queries/feedback/user-feedbacks';
import { SPORT_EVENT_PUBLIC_DATA } from 'common/graphql/queries/sportEvent/sportEventPublicData';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import createFeedbackValidationSchema from 'common/validationSchemas/createFeedbackValidationSchema';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import FeedbackStars from 'components/Other/FeedbackStars';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { openSnackbar } from 'store/actions';
import { userProfileDataVar } from 'utils/apollo/reactivities/userProfileDataVar';
var SportEventFeedbackDialog = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var sportEventUrl = _a.sportEventUrl, initialScore = _a.initialScore, handleClose = _a.handleClose;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _j = useState(), key = _j[0], setKey = _j[1];
    var _k = useState(initialScore || 0), score = _k[0], setScore = _k[1];
    var _l = useState(false), hasFixedScore = _l[0], setHasFixedScore = _l[1];
    var _m = useState(''), scoreErr = _m[0], setScoreErr = _m[1];
    var currentUserId = (_b = useReactiveVar(userProfileDataVar).userProfile) === null || _b === void 0 ? void 0 : _b.id;
    var pathname = useLocation().pathname;
    var match = pathname.match(/\d+/);
    var url = sportEventUrl ? sportEventUrl : match ? match[0] : '';
    var _o = useQuery(SPORT_EVENT_PUBLIC_DATA, {
        variables: {
            url: url
        }
    }), sportEventPublicData = _o.data, sportEventPublicDataLoading = _o.loading, sportEventPublicDataError = _o.error;
    var _p = useLazyQuery(USER_FEEDBACKS), getUserFeedbacks = _p[0], _q = _p[1], userFeedbacks = _q.data, userFeedbacksLoading = _q.loading, userFeedbacksError = _q.error;
    var onLoadingError = function (_a) {
        var errorDetails = _a.errorDetails, message = _a.message, code = _a.code;
        dispatch(openSnackbar({
            message: errorDetails || message || code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var createFeedback = function (data) {
        var _a, _b, _c;
        return useMutation(CREATE_FEEDBACK, {
            variables: {
                createFeedbackData: {
                    targetType: FeedbackTargetTypes.SportEvent,
                    description: (_b = (_a = sportEventPublicData === null || sportEventPublicData === void 0 ? void 0 : sportEventPublicData.sportEvent) === null || _a === void 0 ? void 0 : _a.mainSettings) === null || _b === void 0 ? void 0 : _b.displayName,
                    text: (data === null || data === void 0 ? void 0 : data.text) || '',
                    sportEventId: (_c = sportEventPublicData === null || sportEventPublicData === void 0 ? void 0 : sportEventPublicData.sportEvent) === null || _c === void 0 ? void 0 : _c.id,
                    rate: score > 5 ? 5 : score
                }
            },
            awaitRefetchQueries: true,
            refetchQueries: [USER_FEEDBACKS]
        });
    };
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: t("\u041E\u0442\u0437\u044B\u0432 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D!"),
            severity: SnackbarSeverity.SUCCESS
        }));
        if (key) {
            localStorage.removeItem(key);
        }
    };
    var onError = function (_a) {
        var code = _a.code;
        dispatch(openSnackbar({
            message: code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var handleExecuteMutation = useDynamicMutation(createFeedback, onSuccess, onError).handleExecuteMutation;
    var handleSubmit = function (data) {
        if (score <= 0) {
            setScoreErr('Пожалуйста, оцените турнир');
            return;
        }
        handleExecuteMutation(data);
    };
    var handleChangeWrapper = function (e) {
        formik.setFieldError(e.target.name, undefined); // <- reset error on the field
        formik.handleChange(e); // <- call original Formik's change handler
    };
    var formik = useFormik({
        initialValues: { text: '' },
        validationSchema: createFeedbackValidationSchema,
        onSubmit: handleSubmit,
        validateOnChange: false,
        validateOnBlur: false
    });
    useEffect(function () {
        var _a, _b, _c;
        if (sportEventPublicData && ((_a = sportEventPublicData.sportEvent) === null || _a === void 0 ? void 0 : _a.id)) {
            getUserFeedbacks({
                variables: {
                    sportEventId: (_b = sportEventPublicData.sportEvent) === null || _b === void 0 ? void 0 : _b.id,
                    userId: currentUserId
                }
            });
            if (currentUserId) {
                setKey("fb_".concat(currentUserId, "_").concat((_c = sportEventPublicData.sportEvent) === null || _c === void 0 ? void 0 : _c.id));
            }
        }
    }, [sportEventPublicData]);
    useEffect(function () {
        if (key) {
            var text = localStorage.getItem(key);
            if (text) {
                formik.setFieldValue('text', text);
            }
        }
    }, [key]);
    useEffect(function () {
        if (formik.values['text'] && key) {
            localStorage.setItem(key, formik.values['text']);
        }
    }, [formik.values['text']]);
    useEffect(function () {
        if (sportEventPublicDataError) {
            onLoadingError(sportEventPublicDataError);
        }
    }, [sportEventPublicDataError]);
    useEffect(function () {
        if (userFeedbacksError) {
            onLoadingError(userFeedbacksError);
        }
    }, [userFeedbacksError]);
    var isLoading = sportEventPublicDataLoading || userFeedbacksLoading;
    if (isLoading)
        return _jsx(CircularProgressMui, {}, void 0);
    return !isLoading && sportEventPublicData && userFeedbacks ? (_jsxs("div", __assign({ className: "flex flex-col p-0 pb-20 w-full space-y-5 justify-center min-w-280" }, { children: [_jsxs("div", __assign({ className: "tw-dialog-header" }, { children: [_jsx("p", { children: t('Ваш отзыв о турнире') }, void 0), _jsx("p", { children: ((_d = (_c = sportEventPublicData === null || sportEventPublicData === void 0 ? void 0 : sportEventPublicData.sportEvent) === null || _c === void 0 ? void 0 : _c.mainSettings) === null || _d === void 0 ? void 0 : _d.displayName) || '' }, void 0)] }), void 0), _jsxs("div", __assign({ className: "flex flex-col space-y-10 w-full justify-center" }, { children: [_jsx("div", __assign({ className: "flex w-full justify-center" }, { children: _jsx(FeedbackStars, { score: score, setScore: function (score) {
                                setScoreErr('');
                                setScore(score);
                            }, onClick: userFeedbacks && ((_e = userFeedbacks.userFeedbacks) === null || _e === void 0 ? void 0 : _e.length) > 0
                                ? function () { }
                                : function (starCount) {
                                    if (starCount < score) {
                                        setScore(starCount);
                                    }
                                    else {
                                        setHasFixedScore(true);
                                    }
                                }, hasFixedScore: hasFixedScore, setHasFixedScore: setHasFixedScore, isReadOnly: userFeedbacks && ((_f = userFeedbacks.userFeedbacks) === null || _f === void 0 ? void 0 : _f.length) > 0 }, void 0) }), void 0), scoreErr && (_jsx("div", __assign({ className: "flex w-full justify-center" }, { children: _jsx("p", __assign({ className: "text-red text-12" }, { children: t(scoreErr) }), void 0) }), void 0)), userFeedbacks && !((_g = userFeedbacks.userFeedbacks) === null || _g === void 0 ? void 0 : _g.length) && (_jsxs("form", __assign({ className: "flex flex-col items-center space-y-10 pt-20", onSubmit: formik.handleSubmit, onReset: formik.handleReset }, { children: [_jsx(TextField, { className: "w-288", label: t('Ваш отзыв'), name: "text", multiline: true, value: formik.values['text'], onChange: handleChangeWrapper, error: Boolean(formik.errors['text']), helperText: t(formik.errors['text'] || '') }, void 0), _jsx("p", __assign({ className: "text-12 text-grey" }, { children: t('anonymousFeedback') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Отправить') }), void 0)] }), void 0)), userFeedbacks && ((_h = userFeedbacks.userFeedbacks) === null || _h === void 0 ? void 0 : _h.length) > 0 && (_jsxs("div", __assign({ className: "flex flex-col space-y-10  pt-10" }, { children: [_jsx("div", __assign({ className: "flex w-full justify-center" }, { children: _jsx("p", __assign({ className: "dark:text-white" }, { children: t('Благодарим за отзыв!') }), void 0) }), void 0), userFeedbacks.userFeedbacks[0].text && (_jsx("p", __assign({ className: "text-12 text-grey italic" }, { children: userFeedbacks.userFeedbacks[0].text }), void 0)), _jsxs("p", __assign({ className: "pt-20" }, { children: [_jsxs("span", __assign({ className: "text-grey" }, { children: [t('Хочу узнать больше об Импульс и'), " "] }), void 0), _jsx(Link, __assign({ to: "/donate", onClick: handleClose, className: "no-underline hover:underline text-mainYellow" }, { children: t('поддержать проект') }), void 0)] }), void 0)] }), void 0))] }), void 0)] }), void 0)) : null;
};
export default SportEventFeedbackDialog;
